import React from 'react'
import { Card3Style } from './Card2.styled'
import { CircleStyle } from '../NavBar/NavBar.styled'

const Card2 = ({ heading, total,color,percentage }) => {
  return (
    <Card3Style>
        <div className='card-container'>
            <h2 className='heading'>{heading} <CircleStyle color={color} display={"inline-block"} /></h2>
            <div className='div2'>

                <p className='total'>{total}</p>
                <p className='percentage'>{percentage}</p>
            </div>
        </div>
    </Card3Style>
  )
}

export default Card2